import * as React from "react";
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { LaboratoryTestType, GenderType, FileSystemType } from "../../../common/enums";
import { enumToDropdownArray, fomatDateTimeAsString } from '../../../common/functions/helperFunctions';
import { UserLaboratoryResultModel } from '../../../models/user/userLaboratoryResultModel';
import { LaboratoryResultTypeModel } from "../../../models/user/laboratoryResultTypeModel";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import CSSTransition from 'react-transition-group/CSSTransition';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faTrash, faTimesCircle, faCheck, faTimes, faBan, faFileExcel, faFileWord, faFileCsv,
	faFileImage, faFile, faFilePdf, faDownload, faUpload, faFileArchive, faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import Growl from '../../../common/components/alertMessage/growl';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { PersonalLaboratoryResultModel } from '../../../models/user/personalLaboratoryResultModel';
import Spinner from "../../../common/components/spinner/spinner";
import UserLaboratoryResultService from "../../../services/userLaboratoryResultService";
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Constants from '../../../common/constants';
import { MuiThemeProvider, createMuiTheme, ListItemAvatar } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import Popover from '@material-ui/core/Popover';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { FileModel } from "../../../models/fileModel";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FileSaver from 'file-saver';
import FileService from "../../../services/fileService";
import { LaboratoryResultUnitRangeModel } from '../../../models/laboratoryResultUnitRangeModel';
import AuthService from '../../../services/authService';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	selectedLaboratoryResult: UserLaboratoryResultModel,
	dialogHeader: string;
}

interface IState {
	currentLaboratoryResult: UserLaboratoryResultModel;
	isLoading: boolean;
	validationMessage: string;
	laboratoryResultType: Array<LaboratoryResultDropdownModel>;
	selectedTypes: Array<LaboratoryResultDropdownModel>;
	expandedlaboratoryResultTypes: Array<LaboratoryResultTypeModel>;
	addNew: boolean;
	newLaboratoryResult: string;
	isLoadingSecond: boolean;
	personalLaboratoryResults: Array<PersonalLaboratoryResultModel>;
	isVisibleConfirmDialog: boolean;
	deleteValidationMessage: string;
	personalLaboratoryResult: LaboratoryResultDropdownModel;
	anchorEl: any;
	popover: boolean;
	isVisibleFileConfirmDialog: boolean;
	selectedFile: FileModel;
	deleteFileValidationMessage: string;
	tempId: number;
	minResult: number;
	maxResult: number;
	unitRanges: Array<LaboratoryResultUnitRangeModel>;
	infoPopover: boolean;
	infoAchor: any;
	unitInfo: Array<LaboratoryResultUnitRangeModel>;
	userAge: number;
	userGender: number;
}

class LaboratoryResultAddEditDialog extends React.Component<IProps, IState> {
	growl: any;
	growlSecond: any;
	userLaboratoryResultService = new UserLaboratoryResultService();
	refLefletFile: any;
	fileService = new FileService();
	currentFile: FileModel;
	authService = new AuthService();
	today = new Date();

	constructor(props: IProps) {
		super(props);

		if (!props.selectedLaboratoryResult) {
			props.selectedLaboratoryResult = new UserLaboratoryResultModel();
		}

		this.state = {
			currentLaboratoryResult: props.selectedLaboratoryResult,
			isLoading: false,
			validationMessage: '',
			laboratoryResultType: new Array<LaboratoryResultDropdownModel>(0),
			selectedTypes: new Array<LaboratoryResultDropdownModel>(0),
			expandedlaboratoryResultTypes: Array<LaboratoryResultTypeModel>(0),
			addNew: false,
			newLaboratoryResult: '',
			isLoadingSecond: false,
			personalLaboratoryResults: Array<PersonalLaboratoryResultModel>(0),
			isVisibleConfirmDialog: false,
			deleteValidationMessage: '',
			personalLaboratoryResult: new LaboratoryResultDropdownModel(),
			anchorEl: null,
			popover: false,
			isVisibleFileConfirmDialog: false,
			selectedFile: new FileModel(),
			deleteFileValidationMessage: '',
			tempId: -1,
			minResult: 0,
			maxResult: 0,
			unitRanges: new Array<LaboratoryResultUnitRangeModel>(),
			infoPopover: false,
			infoAchor: null,
			unitInfo: new Array<LaboratoryResultUnitRangeModel>(),
			userAge: 0,
			userGender: 0
		};

		this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
	}

	laboratoryResultEnumToDropdownArray(enumName, isSystem: boolean) {
		let enumAsArray: Array<LaboratoryResultDropdownModel> = [];
		for (var n in enumName) {
			if (typeof enumName[n] === 'number') {
				enumAsArray.push({ value: +enumName[n], label: Translate(n) + " (" + this.getUnitBylaboratoryResultType(+enumName[n]) + ")", isSystem: isSystem, minValue: 0, maxValue: 0 });
			}
		}
		return enumAsArray;
	}

	componentDidMount() {
		this.setState({ isLoading: true });
		this.userLaboratoryResultService.getPersonallaboratoryResults()
			.then(
				(data) => {
					this.setState({
						isLoading: false,
						personalLaboratoryResults: data.personalLaboratoryResults,
						laboratoryResultType: this.laboratoryResultEnumToDropdownArray(LaboratoryTestType, true),
						unitRanges: data.laboratoryResultUnitRanges,
						userAge: data.userAge,
						userGender: data.userGender
					}, this.addPersonalsToDropdown);
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);

	}

	addPersonalsToDropdown = () => {
		if (this.state.personalLaboratoryResults && this.state.personalLaboratoryResults.length > 0) {
			let laboratoryResults: Array<LaboratoryResultDropdownModel> = new Array<LaboratoryResultDropdownModel>(0);
			for (let cond of this.state.personalLaboratoryResults) {
				let laboratoryResult: LaboratoryResultDropdownModel = new LaboratoryResultDropdownModel();
				laboratoryResult.value = cond.personalLaboratoryResultId;
				laboratoryResult.label = cond.personalLaboratoryResultName;
				laboratoryResult.isSystem = false
				laboratoryResults.push(laboratoryResult);
				laboratoryResult.minValue = cond.minValue ? cond.minValue : 0;
				laboratoryResult.maxValue = cond.maxValue ? cond.maxValue : 0;
			}
			this.setState({ laboratoryResultType: this.state.laboratoryResultType.concat(laboratoryResults) });
		}
	}

	handleSaveButton = (event, close) => {
		this.setState({ isLoading: true });
		event.preventDefault();
		if (this.state.currentLaboratoryResult.userLaboratoryResultTypes) {
			for (let i = 0; i < this.state.currentLaboratoryResult.userLaboratoryResultTypes.length; i++) {
				if (!this.state.currentLaboratoryResult.userLaboratoryResultTypes[i].laboratoryResultTypeValue ||
					this.state.currentLaboratoryResult.userLaboratoryResultTypes[i].laboratoryResultTypeValue <= 0) {
					this.growl.show({ severity: 'error', summary: Translate('NotAllEntered') });
					return;
				}
			}
		}
		const laboratoryResult = this.state.currentLaboratoryResult;
		if (!laboratoryResult.laboratoryResultDate) {
			laboratoryResult.laboratoryResultDate = new Date().toUTCString();
		}
		//laboratoryResult.laboratoryResultDate = fomatDateTimeAsString(new Date(laboratoryResult.laboratoryResultDate));
		this.props.saveClick(laboratoryResult, close);
	}

	handleCancelButton = () => {
		this.props.cancelClick();
	}

	handleDropdownChange = (laboratoryResult) => {
		this.setState({ selectedTypes: laboratoryResult }, this.addToList);
	}

	handleChange = (props: LaboratoryResultTypeModel, value) => {
		const laboratoryResult: UserLaboratoryResultModel = { ...this.state.currentLaboratoryResult };
		const laboratoryResults: Array<LaboratoryResultTypeModel> = [...laboratoryResult.userLaboratoryResultTypes];
		let founded = laboratoryResults.findIndex(r => r.laboratoryResultTypeId == props.laboratoryResultTypeId && r.isSystemType == props.isSystemType);
		laboratoryResults[founded].laboratoryResultTypeValue = value;
		laboratoryResult.userLaboratoryResultTypes = [...laboratoryResults];
		this.setState({ currentLaboratoryResult: { ...laboratoryResult } });
	};

	addNewToList = (event) => {
		event.preventDefault();
		this.setState({ addNew: true, selectedTypes: new Array<LaboratoryResultDropdownModel>(0) });
	}

	handleCancelAddNewButton = () => {
		this.setState({ addNew: false, selectedTypes: new Array<LaboratoryResultDropdownModel>(0), newLaboratoryResult: '' });
	}

	addToList = () => {
		let laboratoryResult: UserLaboratoryResultModel = new UserLaboratoryResultModel();
		laboratoryResult = { ...this.state.currentLaboratoryResult };
		let laboratoryResults: Array<LaboratoryResultTypeModel> = laboratoryResult.userLaboratoryResultTypes ? [...laboratoryResult.userLaboratoryResultTypes] : new Array<LaboratoryResultTypeModel>();
		let names: string[] = [];
		for (let selectedType of this.state.selectedTypes) {
			if (laboratoryResults.some(r => (r.laboratoryResultTypeId === selectedType.value && selectedType.isSystem == true && r.isSystemType == true) ||
				(r.isSystemType == false && r.laboratoryResultTypeId == selectedType.value && selectedType.isSystem == false))) {
				names.push(selectedType.label);
				//return;
			}
			else {
				if (selectedType.isSystem) {
					laboratoryResults.push({
						laboratoryResultTypeId: selectedType.value,
						laboratoryResultTypeUnit: this.getUnitBylaboratoryResultType(selectedType.value),
						laboratoryResultTypeValue: 0,
						isSystemType: true, personalLaboratoryResult: '',
						label: '',
						minValue: 0,
						maxValue: 0
					});
				}
				else {
					var name = '';
					let minValue = 0;
					let maxValue = 0;
					for (let cond of this.state.laboratoryResultType) {
						if (cond.value == selectedType.value) {
							name = cond.label;
							if (cond.minValue) {
								minValue = cond.minValue;
							}

							if (cond.maxValue) {
								maxValue = cond.maxValue;
							}
						}
					}
					laboratoryResults.push({
						laboratoryResultTypeId: selectedType.value,
						laboratoryResultTypeUnit: '',
						laboratoryResultTypeValue: 0, isSystemType: false,
						personalLaboratoryResult: name,
						label: '',
						minValue: minValue,
						maxValue: maxValue
					});
				}
			}
		}
		if (names && names.length > 0) {
			this.growlSecond.show({ severity: 'error', summary: Translate('laboratoryResultInList') + ": " + names.join(', ') });
			this.handleCancelAddNewButton;
			return;
		}

		laboratoryResult.userLaboratoryResultTypes = [...laboratoryResults];
		this.setState({ currentLaboratoryResult: { ...laboratoryResult } }, this.handleCancelAddNewButton);
	}

	handleLabResultTypeRemoveClick = (event, condType: number) => {
		event.preventDefault();
		let laboratoryResult: UserLaboratoryResultModel = new UserLaboratoryResultModel();
		laboratoryResult = { ...this.state.currentLaboratoryResult };
		let laboratoryResults: Array<LaboratoryResultTypeModel> = laboratoryResult.userLaboratoryResultTypes ? [...laboratoryResult.userLaboratoryResultTypes] : new Array<LaboratoryResultTypeModel>();
		let index = laboratoryResults.findIndex(d => d.laboratoryResultTypeId === condType);
		laboratoryResults.splice(index, 1);
		laboratoryResult.userLaboratoryResultTypes = [...laboratoryResults];
		this.setState({ currentLaboratoryResult: { ...laboratoryResult } });
	}

	getUnitBylaboratoryResultType(condType: LaboratoryTestType) {
		switch (condType) {
			case LaboratoryTestType.Hemoglobin:
				return 'g/L';
			case LaboratoryTestType.TotalCholesterol:
			case LaboratoryTestType.HighDensityLipoproteinCholesterol:
			case LaboratoryTestType.LowDensityLipoproteinCholesterol:
			case LaboratoryTestType.Triglycerides:
			case LaboratoryTestType.BloodSugar:
				return 'mmol/l';
			default:
				return '';
		}
	}

	getPlaceHolder(condType: LaboratoryTestType) {
		switch (condType) {
			case LaboratoryTestType.Hemoglobin:
				return Translate('EnterHemoglobin');
			case LaboratoryTestType.TotalCholesterol:
				return Translate('EnterTotalCholesterol');
			case LaboratoryTestType.HighDensityLipoproteinCholesterol:
				return Translate('EnterHDL');
			case LaboratoryTestType.LowDensityLipoproteinCholesterol:
				return Translate('EnterLDL');
			case LaboratoryTestType.Triglycerides:
				return Translate('EnterTriglycerides');
			case LaboratoryTestType.BloodSugar:
				return Translate('EnterBloodSugar');
			default:
				return '';
		}
	}

	getInputElement = (rowData) => {
		if (rowData.isSystemType) {
			return <TextField
				autoComplete="off"
				label={getEnumLabel(rowData.laboratoryResultTypeId, LaboratoryTestType, true) + " (" + rowData.laboratoryResultTypeUnit + ")"}
				placeholder={this.getPlaceHolder(rowData.laboratoryResultTypeId)}
				type="number"
				helperText={this.getHelperText(rowData)}
				value={rowData.laboratoryResultTypeValue || ''}
				name={rowData.laboratoryResultTypeId + 'system'}
				onChange={(e) => this.handleChange(rowData, e.target['value'])}></TextField>;

		}
		else {
			let helperTextLabel: string = '';
			if (rowData.minValue > 0 && rowData.maxValue > 0) {
				helperTextLabel += Translate('Yours reference values') + ": " + rowData.minValue.toString() + " - " + rowData.maxValue.toString();
			}
			if (rowData.minValue > 0 && rowData.maxValue <= 0) {
				helperTextLabel += Translate('Yours reference values') + ": " + "> " + rowData.minValue.toString() + ")";
			}
			if (rowData.minValue <= 0 && rowData.maxValue > 0) {
				helperTextLabel += Translate('Yours reference values') + ": " + "< " + rowData.maxValue.toString();
			}
			return <TextField
				autoComplete="off"
				label={rowData.personalLaboratoryResult}
				type="number"
				helperText={helperTextLabel}
				value={rowData.laboratoryResultTypeValue || ''}
				name={rowData.laboratoryResultTypeId + 'personal'}
				onChange={(e) => this.handleChange(rowData, e.target['value'])}></TextField>;
		}
	}

	rowExpansionTemplate(rowData: LaboratoryResultTypeModel) {
		const classrs = {
			backgroundColor: '#17a2b8',
			color: 'white',
			border: 'none',
			borderRadius: '3px',
			marginRight: ".5em",
			fontSize: 16,
		}

		return (
			<div className="item-actions-panel">
				<div style={{ width: '100%' }}>
					{this.getInputElement(rowData)}
				</div>
				<div style={{ marginLeft: 5, display: 'flex' }}>
					{rowData.isSystemType ?
						<span style={{ marginRight: 10 }} aria-describedby={"info-pop"}>
							<a href='' onClick={(e) => this.openInfoPopover(e, rowData)}>
								<FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: '1.3em', margin: '0 2px' }} />
							</a>
						</span>
						: null}
					<span>
						<a href='' onClick={(e) => this.handleLabResultTypeRemoveClick(e, rowData.laboratoryResultTypeId)} >
							<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
						</a>
					</span>
				</div>
			</div>
		);
	}
	expandData = (data: LaboratoryResultTypeModel) => {
		if (!this.state.expandedlaboratoryResultTypes.some(r => r.laboratoryResultTypeId == data.laboratoryResultTypeId) || this.state.expandedlaboratoryResultTypes.length == 0) {
			this.setState({ expandedlaboratoryResultTypes: [...this.state.expandedlaboratoryResultTypes, data] });
		} else {
			this.setState({ expandedlaboratoryResultTypes: this.state.expandedlaboratoryResultTypes.filter(r => r.laboratoryResultTypeId != data.laboratoryResultTypeId) });
		}
	}

	condTypeTemplate(option) {
		return (
			<div style={{ borderBottom: '1px #ccc solid', marginBottom: '5px', fontSize: 15, paddingBottom: 5 }}>
				{option.label}
			</div>
		);
	}

	newLaboratoryResultChange = (value) => {
		this.setState({ newLaboratoryResult: value });
	}

	changeMinAndMax = (type, value) => {
		if (type == 'minResult') {
			this.setState({ minResult: value });
		}
		if (type == 'maxResult') {
			this.setState({ maxResult: value });
		}
	}

	handleAddButton = (e) => {
		e.preventDefault();
		if (this.state.laboratoryResultType.some(c => c.label.toLocaleLowerCase() == this.state.newLaboratoryResult.trim().toLocaleLowerCase())) {
			this.growlSecond.show({ severity: 'warning', summary: Translate('Characteristic already exist') });
			//this.setState({ addNew: false, newLaboratoryResult: '' });
			return;
		}

		if ((this.state.minResult && this.state.minResult < 0) || (this.state.maxResult && this.state.maxResult < 0)) {
			this.growlSecond.show({ severity: 'warning', summary: Translate('Enter valid value') });
			//this.setState({ addNew: false, newLaboratoryResult: '' });
			return;
		}
		this.setState({
			isLoading: true
		});
		let newPersonal: PersonalLaboratoryResultModel = new PersonalLaboratoryResultModel();
		newPersonal.personalLaboratoryResultName = this.state.newLaboratoryResult;
		if (this.state.minResult) {
			newPersonal.minValue = this.state.minResult;
		}
		if (this.state.maxResult) {
			newPersonal.maxValue = this.state.maxResult;
		}

		this.userLaboratoryResultService.createPersonallaboratoryResult(newPersonal)
			.then(
				(data) => {
					let laboratoryResult: LaboratoryResultDropdownModel = new LaboratoryResultDropdownModel();
					laboratoryResult.label = JSON.parse(JSON.stringify(this.state.newLaboratoryResult));
					laboratoryResult.value = data;
					laboratoryResult.minValue = this.state.minResult;
					laboratoryResult.maxValue = this.state.maxResult;

					laboratoryResult.isSystem = false;
					this.setState({
						isLoading: false,
						laboratoryResultType: this.state.laboratoryResultType.concat(laboratoryResult),
						newLaboratoryResult: '',
						popover: false,
						minResult: 0,
						maxResult: 0
					});
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	handleDateChange = (value) => {
		const laboratoryResult: UserLaboratoryResultModel = { ...this.state.currentLaboratoryResult };
		laboratoryResult.laboratoryResultDate = value;
		this.setState({ currentLaboratoryResult: { ...laboratoryResult } })
	}

	handleDeleteClick = (personalLaboratoryResult: LaboratoryResultDropdownModel, e) => {
		e.preventDefault();
		this.setState({
			isVisibleConfirmDialog: true,
			personalLaboratoryResult: personalLaboratoryResult,
			deleteValidationMessage: Translate('PersonalTestConfirm')
		});
	}

	removepersonalLaboratoryResult = (personalLaboratoryResult: LaboratoryResultDropdownModel) => {
		this.setState({ isLoadingSecond: true });
		this.userLaboratoryResultService.deletePersonallaboratoryResult(personalLaboratoryResult.value)
			.then(
				(data) => {
					if (data == false) {
						this.growlSecond.show({ severity: 'error', summary: Translate('Test is used') });
						this.setState({ isLoadingSecond: false });
						return;
					}
					if (this.state.currentLaboratoryResult && this.state.currentLaboratoryResult.userLaboratoryResultTypes &&
						this.state.currentLaboratoryResult.userLaboratoryResultTypes.some(r => r.isSystemType == false && r.laboratoryResultTypeId == personalLaboratoryResult.value)) {
						let laboratoryResult: UserLaboratoryResultModel = new UserLaboratoryResultModel();
						laboratoryResult = { ...this.state.currentLaboratoryResult };
						let laboratoryResults: Array<LaboratoryResultTypeModel> = laboratoryResult.userLaboratoryResultTypes ? [...laboratoryResult.userLaboratoryResultTypes] : new Array<LaboratoryResultTypeModel>();
						let index = laboratoryResults.findIndex(d => d.laboratoryResultTypeId === personalLaboratoryResult.value);
						laboratoryResults.splice(index, 1);
						laboratoryResult.userLaboratoryResultTypes = [...laboratoryResults];
						this.setState({
							currentLaboratoryResult:
								{ ...laboratoryResult },
							isLoadingSecond: false,
							laboratoryResultType: this.laboratoryResultEnumToDropdownArray(LaboratoryTestType, true),
							selectedTypes: new Array<LaboratoryResultDropdownModel>(0)
						}, () => this.getpersonalLaboratoryResults(true));
					}
					else {
						this.setState({
							isLoadingSecond: false,
							laboratoryResultType: this.laboratoryResultEnumToDropdownArray(LaboratoryTestType, true),
							selectedTypes: new Array<LaboratoryResultDropdownModel>(0)
						}, () => this.getpersonalLaboratoryResults(true));
					}
				},
				error => {
					this.growlSecond.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoadingSecond: false
					});
				}
			);
	}

	getpersonalLaboratoryResults = (isFromDelete: boolean) => {
		this.setState({ isLoading: true });
		this.userLaboratoryResultService.getPersonallaboratoryResults()
			.then(
				(data) => {
					if (isFromDelete) {
						this.setState({
							isLoading: false,
							personalLaboratoryResults: data.personalLaboratoryResults
						}, this.addPersonalsToDropdown);
					}
					else {
						this.setState({
							isLoading: false,
							personalLaboratoryResults: data.personalLaboratoryResults,
						});
					}
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	selectTypes = (laboratoryResult: LaboratoryResultDropdownModel) => {
		let selectedTypes: Array<LaboratoryResultDropdownModel> = [...this.state.selectedTypes];
		if (selectedTypes.some(r => r.value == laboratoryResult.value && r.isSystem == r.isSystem)) {
			for (let i = 0; i < selectedTypes.length; i++) {
				if (selectedTypes[i].value == laboratoryResult.value && selectedTypes[i].isSystem == laboratoryResult.isSystem) {
					selectedTypes.splice(i, 1);
					i--;
				}
			}
		}
		else {
			selectedTypes.push(laboratoryResult);
		}
		this.setState({ selectedTypes: selectedTypes });
	}

	handleSaveAddButton = () => { }

	handleClick = (e) => {
		e.preventDefault();
		this.setState({ popover: true, anchorEl: e.currentTarget });
	}

	openInfoPopover = (e, rowData: LaboratoryResultTypeModel) => {
		e.preventDefault();
		let unitInfo: string = '';
		if (rowData.isSystemType) {
			let unitRanges = [...this.state.unitRanges];
			let found = unitRanges.filter(r => r.laboratoryResultSystemTypeId == rowData.laboratoryResultTypeId);
			this.setState({ infoPopover: true, infoAchor: e.currentTarget, unitInfo: found });
		}

	}

	handleClose = () => {
		this.setState({
			popover: false, maxResult: 0, minResult: 0
			, newLaboratoryResult: ''
		})
	}

	handleInfoClose = () => {
		this.setState({
			infoPopover: false, unitInfo: new Array<LaboratoryResultUnitRangeModel>(0)
		});
	}

	handleAddCharacteristicKeyPress = (e) => {
		if (e.key === 'Enter' && this.state.newLaboratoryResult && this.state.newLaboratoryResult.trim() != '') {
			this.handleAddButton(e);
		}
	}

	handleOnChange(event) {
		let file: File = event.target.files[0];
		let valid: boolean = true;
		let fileExtension: string = '';
		if (file) {
			fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

			this.currentFile = new FileModel();

			if (!fileExtension.match(/(doc|pdf|docx|jpg|jpeg|png|rar|zip|csv|xls|xlsx)$/i)) {
				valid = false;
				this.growl.show({ severity: 'error', summary: Translate('Allowed file types are') + ' (doc, pdf, docx, jpg, jpeg, png, rar, zip, csv, xls, xlsx)' });
			}
			let allSize: number = 0;
			if (this.state.currentLaboratoryResult.fileResults && this.state.currentLaboratoryResult.fileResults.length > 0) {
				allSize = this.state.currentLaboratoryResult.fileResults.reduce((a, b) => a + b.fileSizeInBytes, 0);
			}
			if (file.size + allSize > parseInt(Constants.MaxLabResultFileSize || '31457280')) {
				valid = false;
				this.growl.show({ severity: 'error', summary: Translate('File size is greater than') + " " + HelperFunctions.formatBytes(Constants.MaxLabResultFileSize, 3) });
				//message += Translate('File size is greater than')+" " + HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3) + '.<br />';
			}

			if (valid) {
				this.currentFile.fileName = file.name;
				this.currentFile.fileType = fileExtension;
				this.currentFile.fileSizeInBytes = file.size;
				this.currentFile.medicineLeafletTypeId = 1;
				let content;
				let reader = new FileReader();
				reader.addEventListener("load", () => {
					this.currentFile.fileContent = reader.result;
					let labResult = { ...this.state.currentLaboratoryResult }
					if (!labResult.fileResults) {
						labResult.fileResults = new Array<FileModel>(0)
					}
					labResult.fileResults.push(this.currentFile);
					this.setState({ currentLaboratoryResult: labResult });
				}, false);

				if (file) {
					reader.readAsDataURL(file);
				}
			}
		}
	}

	getDocIcon(ext?: string) {
		switch (ext) {
			case 'jpg':
			case 'jpeg':
				return faFileImage;
			case 'doc':
			case 'docx':
				return faFileWord;
			case 'xls':
			case 'csv':
				return faFileExcel;
			case 'pdf':
				return faFilePdf;
			case 'zip':
			case 'rar':
				return faFileArchive;
			default:
				return faFile;
		}
	}

	handleFileRemoveClick = (e, selectedFile) => {
		e.preventDefault();
		this.setState({
			isVisibleFileConfirmDialog: true,
			selectedFile: selectedFile,
			deleteFileValidationMessage: Translate('FileRemove')
		});
	}

	removeFile = (file: FileModel) => {
		let laboratoryResult: UserLaboratoryResultModel = new UserLaboratoryResultModel();
		laboratoryResult = { ...this.state.currentLaboratoryResult };
		let atachedFiles: Array<FileModel> = laboratoryResult.fileResults ? [...laboratoryResult.fileResults] : new Array<FileModel>();
		let index = atachedFiles.indexOf(file);
		atachedFiles.splice(index, 1);
		laboratoryResult.fileResults = [...atachedFiles];
		this.setState({
			currentLaboratoryResult:
				{ ...laboratoryResult }
		});
	}

	getPersonalLabel = (personal: LaboratoryResultDropdownModel) => {
		let label: string = personal.label;
		if (personal.minValue > 0 && personal.maxValue > 0) {
			label += " (" + personal.minValue.toString() + " - " + personal.maxValue.toString() + ")";
		}
		if (personal.minValue > 0 && personal.maxValue <= 0) {
			label += " ( > " + personal.minValue.toString() + ")";
		}
		if (personal.minValue <= 0 && personal.maxValue > 0) {
			label += " ( < " + personal.maxValue.toString() + ")";
		}
		return label;
	}

	getGender = (gender: number) => {
		return gender == GenderType.Male ? Translate('Male') : Translate('Female');
	}

	getHelperText = (rowData: LaboratoryResultTypeModel) => {
		let rValues: string = '';
		let ranges = this.state.unitRanges.filter(r => r.laboratoryResultSystemTypeId == rowData.laboratoryResultTypeId);
		if (ranges.length == 1) {
			if (ranges[0].minValue > 0 && ranges[0].maxValue > 0) {
				rValues = ranges[0].minValue.toString() + " - " + ranges[0].maxValue.toString();
			}
			if (ranges[0].minValue <= 0 && ranges[0].maxValue > 0) {
				rValues = "< " + ranges[0].maxValue.toString();
			}
			if (ranges[0].minValue > 0 && ranges[0].maxValue <= 0) {
				rValues = "> " + ranges[0].minValue.toString();
			}
		}
		else {
			for (var range of ranges) {
				let isGenderEqual: boolean = false;
				let isMinAgeValid: boolean = false;
				let isMaxAgeEqual: boolean = false;
				if ((range.genderTypeId && this.state.userGender && range.genderTypeId == this.state.userGender) || !range.genderTypeId) {
					isGenderEqual = true;
				}

				if ((range.minAge && this.state.userAge && range.minAge <= this.state.userAge) || !range.minAge) {
					isMinAgeValid = true;
				}

				if ((range.maxAge && this.state.userAge && range.maxAge >= this.state.userAge) || !range.maxAge) {
					isMaxAgeEqual = true;
				}

				if (isGenderEqual && isMinAgeValid && isMaxAgeEqual) {
					if (range.minValue > 0 && range.maxValue > 0) {
						rValues = range.minValue.toString() + " - " + range.maxValue.toString();
					}
					if (range.minValue <= 0 && range.maxValue > 0) {
						rValues = "< " + range.maxValue.toString();
					}
					if (range.minValue > 0 && range.maxValue <= 0) {
						rValues = "> " + range.minValue.toString();
					}
				}
			}
		}
		let returnedString = rValues != '' ? Translate('Yours reference values') + ": " + rValues : '';
		return returnedString;
	}

	downoladFile = (event, file: FileModel) => {
		event.preventDefault();
		this.setState({ isLoading: true });
		this.fileService.openFile(file.fileId, file.fileName, FileSystemType.LaboratoryResults)
			.then(
				(data) => {
					FileSaver.saveAs(data, file.fileName)
					this.setState({ isLoading: false });
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	public render() {
		const { isLoading, currentLaboratoryResult, laboratoryResultType, selectedTypes, isLoadingSecond, anchorEl, popover } = this.state;

		return (
			<>

				<Dialog
					open={this.props.isVisible}
					onClose={this.handleCancelButton}
					fullWidth
					aria-labelledby="responsive-dialog-title"
				>
					<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{this.props.dialogHeader}</Modal.DialogTitle>
					<Modal.DialogContent>
						<div style={{
							minHeight: window.innerWidth < Constants.device.desktop ? 200 : 400,
							minWidth: window.innerWidth < Constants.device.desktop ? 'unset' : 400, maxHeight: 600
						}}>
							<Growl ref={(el) => this.growl = el} />
							{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
							<div style={{ height: '65px' }}>
								<div style={{ maxWidth: '350px', float: 'left' }}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											disableFuture
											format={Translate('DateTimeFormat')}
											margin="normal"
											label={Translate('Date')}
											value={currentLaboratoryResult.laboratoryResultDate ? new Date(currentLaboratoryResult.laboratoryResultDate) : this.today}
											onChange={(e) => this.handleDateChange(e)}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<div style={{ display: 'flex', flexFlow: window.innerWidth < Constants.device.desktop ? 'wrap' : 'row' }}>
								<Card className="lab-result-card" style={{ marginRight: window.innerWidth < Constants.device.desktop ? 'unset' : 10 }}>
									<CardContent>
										<div style={{ display: 'flex', marginBottom: '20px' }}>
											<h2 style={{ width: '100%' }}>{Translate('Laboratory result')}</h2>
											<div>
												<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.addNewToList(e)}>
													<AddIcon />
												</Fab>
											</div>
										</div>
										<div style={{ minHeight: window.innerWidth < Constants.device.desktop ? '150px' : '250px', maxHeight: '300px', overflowY: 'auto', paddingRight: '5px', width: '100%' }}>
											<ul className="list-items">
												{currentLaboratoryResult && currentLaboratoryResult.userLaboratoryResultTypes &&
													currentLaboratoryResult.userLaboratoryResultTypes.length > 0 ?
													currentLaboratoryResult.userLaboratoryResultTypes.map((m: LaboratoryResultTypeModel) =>
														<li style={{ border: 'none', marginTop: '5px', marginBottom: '15px', minHeight: 65 }} key={m.isSystemType ? m.laboratoryResultTypeId + 'system' : m.laboratoryResultTypeId + 'personal'}>
															<CSSTransition in={true}
																timeout={300} classNames="list-slide">
																{this.rowExpansionTemplate(m)}
															</CSSTransition>
														</li>
													) : <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate("Add Lab result")}</i></span>}
											</ul>
										</div>
										<Popover
											id={"info-pop"}
											open={this.state.infoPopover}
											anchorEl={this.state.infoAchor}
											onClose={this.handleInfoClose}
											anchorOrigin={{
												vertical: 'top',
												horizontal: 'right',
											}}
											transformOrigin={{
												vertical: 'bottom',
												horizontal: 'right',
											}}
										>
											<div style={{ padding: 20, minWidth: 250 }}>
												<h4 style={{ marginBottom: 10 }}>{Translate('Reference values')}</h4>
												{this.state.unitInfo.map((unit: LaboratoryResultUnitRangeModel, index) => {
													return <div style={{ backgroundColor: '#f2f2f2', padding: 5, borderRadius: 4, marginBottom: 10 }}
														key={unit.laboratoryResultUnitRangeId + 'unitInfo'}>
														{unit.genderTypeId > 0 ?
															<span>
																{this.getGender(unit.genderTypeId) + ' '}
															</span>
															: null}
														{unit.minAge > 0 && unit.maxAge > 0 ?
															<span>
																{"(" + unit.minAge + '-' + unit.maxAge + " " + Translate('AgeAbb') + ") "}
															</span>
															: null}
														{unit.minAge <= 0 && unit.maxAge > 0 ?
															<span>
																{"(" + Translate('Under') + ' ' + unit.maxAge + " " + Translate('AgeAbb') + ") "}
															</span>
															: null}
														{unit.maxAge <= 0 && unit.minAge > 0 ?
															<span>
																{"(" + Translate("Over") + unit.minAge + " " + Translate('AgeAbb') + ") "}
															</span>
															: null}

														{unit.minValue > 0 && unit.maxValue > 0 && (unit.genderTypeId || unit.minAge || unit.maxAge) ?
															<span>
																-  <span style={{ fontWeight: 600 }}>{unit.minValue + '-' + unit.maxValue}</span>
															</span>
															: null}
														{unit.minValue > 0 && unit.maxValue > 0 && !unit.genderTypeId && !unit.minAge && !unit.maxAge ?
															<span>
																<span style={{ fontWeight: 600 }}>{unit.minValue + '-' + unit.maxValue}</span>
															</span>
															: null}
														{unit.minValue <= 0 && unit.maxValue > 0 && (unit.genderTypeId || unit.minAge || unit.maxAge) ?
															<span>
																- <span style={{ fontWeight: 600 }}>{"< " + unit.maxValue}</span>
															</span>
															: null}
														{unit.maxValue <= 0 && unit.minValue > 0 && (unit.genderTypeId || unit.minAge || unit.maxAge) ?
															<span>
																- <span style={{ fontWeight: 600 }}>{"> " + unit.minValue}</span>
															</span>
															: null}
														{unit.minValue <= 0 && unit.maxValue > 0 && !unit.genderTypeId && !unit.minAge && !unit.maxAge ?
															<span>
																<span style={{ fontWeight: 600 }}>{"< " + unit.maxValue}</span>
															</span>
															: null}
														{unit.maxValue <= 0 && unit.minValue > 0 && !unit.genderTypeId && !unit.minAge && !unit.maxAge ?
															<span>
																<span style={{ fontWeight: 600 }}>{"> " + unit.minValue}</span>
															</span>
															: null}
													</div>
												})}
											</div>
										</Popover>
									</CardContent>
								</Card>
								<Card className="lab-result-card" style={{ marginLeft: window.innerWidth < Constants.device.desktop ? 'unset' : 10 }}>
									<CardContent>
										<div style={{ display: 'flex', marginBottom: '20px' }}>
											<div style={{ width: '100%' }}>
												<h2>{Translate('Files')}</h2>
												<span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 11 }}>
													{Translate("Allowed formats")}: <strong>doc, pdf, docx, jpg, jpeg, png, rar, zip, csv, xls, xlsx</strong> <br />
													{Translate("Max total file size")}: <strong>{HelperFunctions.formatBytes(Constants.MaxLabResultFileSize, 3)}</strong>
												</span>
											</div>
											<div>
												<input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refLefletFile = el} />
												<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.refLefletFile.click()}>
													<AddIcon />
												</Fab>
											</div>
										</div>
										<div style={{ minHeight: '150px', maxHeight: '200px', overflowY: 'auto', paddingRight: '5px', width: '100%' }}>
											<ul className="list-items">
												{currentLaboratoryResult && currentLaboratoryResult.fileResults &&
													currentLaboratoryResult.fileResults.length > 0 ?
													currentLaboratoryResult.fileResults.map((m: FileModel, index) =>
														<li style={{}} key={m.fileId ? m.fileId + 'doc' : index + 'temp'}>
															<div className="item-icon">
																<FontAwesomeIcon icon={this.getDocIcon(m.fileName.split('.').pop())} style={{ fontSize: 23 }}></FontAwesomeIcon>
															</div>
															<div className="item-info" style={{ width: 'calc(100% - 90px)' }}>
																<div className="item-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
																	{m.fileId > 0 ?
																		<a href="" onClick={(e) => this.downoladFile(e, m)}
																			target="_blank">{m.fileName}</a> :
																		m.fileName}
																</div>
															</div>
															<div className="item-actions">
																{m.fileId > 0 ?
																	<a href="" target="_blank" onClick={(e) => this.downoladFile(e, m)}
																		title={Translate('Download')} style={{ paddingRight: 10 }}>
																		<FontAwesomeIcon icon={faDownload} style={{ fontSize: '1.3em', margin: '0 2px' }} />
																	</a> : null}
																<a href='' onClick={(e) => this.handleFileRemoveClick(e, m)} title={Translate('Remove')} >
																	<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
																</a>
															</div>
														</li>
													) : <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate("Add files")}</i></span>}
											</ul>
										</div>
									</CardContent>
								</Card>
							</div>
						</div>
					</Modal.DialogContent>
					<Modal.DialogActions>
						<div>
							<Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
								<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
								{Translate('Cancel')}
							</Button>
							<Button variant="contained" size="small" color="primary" onClick={(e) => this.handleSaveButton(e, true)}
								disabled={(!currentLaboratoryResult || !currentLaboratoryResult.userLaboratoryResultTypes || currentLaboratoryResult.userLaboratoryResultTypes.length == 0) &&
									(!currentLaboratoryResult || !currentLaboratoryResult.fileResults || currentLaboratoryResult.fileResults.length == 0)}>
								<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
								{Translate('Save')}
							</Button>
						</div>
					</Modal.DialogActions>
				</Dialog>
				<MuiThemeProvider theme={Constants.smallDialogTheme}>
					<Dialog
						open={this.state.addNew}
						onClose={this.handleCancelAddNewButton}
						fullWidth
					>
						<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelAddNewButton}>{Translate("Choose test")}</Modal.DialogTitle>
						<Modal.DialogContent>
							{isLoading ? <Spinner /> : null}
							<Growl ref={(el) => this.growlSecond = el} />
							<div style={{ width: '100%', float: 'left', maxHeight: '300px', overflowY: 'auto', marginBottom: 15 }}>
								<ul className="list-items">
									{this.state.laboratoryResultType && this.state.laboratoryResultType.length > 0 ?
										this.state.laboratoryResultType.map((m: LaboratoryResultDropdownModel) =>
											<li key={m.isSystem ? m.value + 'data-cond' : m.value + 'personal'}>
												<div className="item-actions" style={{ paddingLeft: 5 }}>
													<Checkbox
														checked={selectedTypes.some(r => r.value == m.value && r.isSystem == m.isSystem)}
														onChange={e => this.selectTypes(m)}
														color="primary"
													/>
												</div>
												<div className="item-name-with-radio" onClick={() => this.selectTypes(m)}>
													{m.isSystem ? m.label : this.getPersonalLabel(m)}
												</div>
												{m.isSystem ?
													null
													:
													<div className="item-actions" style={{ paddingLeft: 5 }}>
														<a href='' onClick={(e) => this.handleDeleteClick(m, e)} title={Translate('Remove')} >
															<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
														</a>
													</div>}
											</li>
										) : Translate('No records found')}
								</ul>
							</div>
							<div>
								<a href="" aria-describedby={"boo"} onClick={(e) => this.handleClick(e)}>
									{Translate("New laboratory test")}
								</a>

								<Popover
									id={"boo"}
									open={popover}
									anchorEl={anchorEl}
									onClose={this.handleClose}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									transformOrigin={{
										vertical: 'bottom',
										horizontal: 'right',
									}}
								>
									<div style={{ padding: 20 }}>
										<div>
											<TextField
												autoComplete="off"
												label={Translate('Name of characteristic')}
												type="text"
												value={this.state.newLaboratoryResult || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.newLaboratoryResultChange(e.target['value'])}></TextField>
										</div>
										<div>
											<TextField
												autoComplete="off"
												label={Translate('Min')}
												type="number"
												value={this.state.minResult || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.changeMinAndMax('minResult', e.target['value'])}></TextField>
											<TextField
												autoComplete="off"
												label={Translate('Max')}
												type="number"
												value={this.state.maxResult || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.changeMinAndMax('maxResult', e.target['value'])}></TextField>
										</div>
										<div style={{ margin: "10px 0 10px 0", width: '100%', float: 'right', textAlign: 'right' }}>
											<Button variant="contained" size="small" onClick={this.handleClose} style={{ marginRight: 10 }}>
												<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
												{Translate('Cancel')}
											</Button>
											<Button variant="contained" size="small" color="primary" onClick={(e) => this.handleAddButton(e)}
												disabled={!this.state.newLaboratoryResult || this.state.newLaboratoryResult.trim() == ''}>
												<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
												{Translate('Create')}
											</Button>
										</div>
									</div>
								</Popover>

							</div>
						</Modal.DialogContent>
						<Modal.DialogActions>
							<div>
								<Button variant="contained" size="small" onClick={this.handleCancelAddNewButton} style={{ marginRight: '10px' }}>
									<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
									{Translate('Cancel')}
								</Button>
								<Button variant="contained" size="small" color="primary" onClick={this.addToList}
									disabled={!selectedTypes || !selectedTypes.length || selectedTypes.length == 0}>
									<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
									{Translate('Add')}
								</Button>
							</div>
						</Modal.DialogActions>
					</Dialog>
				</MuiThemeProvider>

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmDialog}
					yesClick={(e) => { this.setState({ isVisibleConfirmDialog: false }, () => this.removepersonalLaboratoryResult(this.state.personalLaboratoryResult)) }}
					noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleFileConfirmDialog}
					yesClick={(e) => { this.setState({ isVisibleFileConfirmDialog: false }, () => this.removeFile(this.state.selectedFile)) }}
					noClick={() => { this.setState({ isVisibleFileConfirmDialog: false, deleteFileValidationMessage: '' }) }}>
					{this.state.deleteFileValidationMessage}
				</ConfirmDialog>
			</>
		)
	}
}

export default LaboratoryResultAddEditDialog;

class LaboratoryResultDropdownModel {
	value: number;
	label: string;
	isSystem: boolean;
	minValue: number;
	maxValue: number;
}